import { render, staticRenderFns } from "./SiteNavbar.vue?vue&type=template&id=262b19e1&scoped=true"
import script from "./SiteNavbar.vue?vue&type=script&lang=js"
export * from "./SiteNavbar.vue?vue&type=script&lang=js"
import style0 from "./SiteNavbar.vue?vue&type=style&index=0&id=262b19e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262b19e1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteBanner: require('/home/rohit/Documents/GitHub/aibuddha-website/components/SiteBanner.vue').default})
